import { createFileRoute, notFound } from '@tanstack/react-router';
import { ScoreSettingsPage } from '../components/scoring/score-settings-page.js';
import { SCORE_DATASETS, type ScoreDataset } from '../lib/scores.js';

export const Route = createFileRoute('/settings/scoring/$entity')({
  beforeLoad: ({ params }) => {
    if (!(SCORE_DATASETS as readonly string[]).includes(params.entity)) throw notFound();
  },
  component: ScoringRoute,
});

function ScoringRoute() {
  const { entity } = Route.useParams();
  // Keyed so moving between scores never carries one editor's state onto another.
  return <ScoreSettingsPage key={entity} dataset={entity as ScoreDataset} />;
}
